var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFuzhi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.5a1 1 0 00-1 1v1h-2a1 1 0 00-1 1v9a1 1 0 001 1h9a1 1 0 001-1v-2h1a1 1 0 001-1v-8a1 1 0 00-1-1h-8zm7 9h1v-8h-8v1h6a1 1 0 011 1v6zm-10-6h9v9h-9v-9z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5h5M4.5 10.5h5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_fuzhi.dfc5b3d8.svg";
export { SvgTongyongFuzhi as ReactComponent };